// extracted by css-extract-rspack-plugin
export default {"HeadlineImage":"HeadlineImage-oXcer0","headlineImage":"HeadlineImage-oXcer0"};